export const enum AdminObjectsAnalogSortNames {
	NUMBER_ID = 'id',
	NAME = 'name',
	TH_NAME = 'th_name',
}
